import React, { useState } from "react";
import "./InputSearchs.css";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { useMediaQuery } from '@react-hook/media-query';
import { loadResource } from '../storeData';
import { searchImageUrl } from '../imageUrl';

export default function InputSearchs() {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState({});
    const [searchLoaded, setSearchLoaded] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const isScreenLarge = useMediaQuery('(min-width: 1024px)');

    const ensureSearchData = () => {
        if (searchLoaded) {
            return Promise.resolve({ productos, categorias });
        }

        setLoadingSearch(true);
        return Promise.all([
            loadResource('productos'),
            loadResource('categorias'),
        ])
            .then(([productosData, categoriasData]) => {
                const nextProductos = productosData || [];
                const nextCategorias = categoriasData || [];

                setProductos(nextProductos);
                setCategorias(nextCategorias);
                setSearchLoaded(true);

                return { productos: nextProductos, categorias: nextCategorias };
            })
            .catch(error => {
                console.error('Error al cargar busqueda:', error);
                return { productos: [], categorias: [] };
            })
            .finally(() => setLoadingSearch(false));
    };

    const buildResults = (term, productosList, categoriasList) => {
        if (!term) return [];

        return categoriasList.map((categoria) => {
            const productosFiltrados = productosList.filter((producto) => (
                String(producto.idCategoria) === String(categoria.idCategoria) &&
                (
                    String(producto.titulo || '').toLowerCase().includes(term) ||
                    String(categoria.categoria || '').toLowerCase().includes(term)
                )
            ));

            return productosFiltrados.length > 0 ? { categoria, productos: productosFiltrados } : null;
        }).filter(Boolean);
    };

    const updateResults = (term, productosList, categoriasList) => {
        const results = buildResults(term, productosList, categoriasList);
        setFilteredResults(results);
        setShowResults(term !== "");
        setNoResults(term !== "" && results.length === 0);
    };

    const handleSearch = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        if (!term) {
            updateResults('', productos, categorias);
            return;
        }

        ensureSearchData().then(({ productos: productosList, categorias: categoriasList }) => {
            updateResults(term, productosList, categoriasList);
        });
    };

    const handleShowMore = (categoria) => {
        setVisibleProducts(prev => ({
            ...prev,
            [categoria?.idCategoria]: (prev[categoria?.idCategoria] || 5) + 5
        }));
    };

    const openModal = () => {
        setModalIsOpen(true);
        ensureSearchData();
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const renderResults = (LinkComponent = 'a') => (
        <>
            {loadingSearch && <p>Cargando...</p>}
            {filteredResults.map(({ categoria, productos }) => (
                <div key={categoria.idCategoria} className="sectionSearch">
                    <h3>{categoria.seccion ? `${categoria.seccion} / ` : ''}{categoria.categoria}</h3>
                    <hr />
                    {productos?.slice(0, visibleProducts[categoria?.idCategoria] || 5).map((producto) => {
                        const href = `/producto/${producto.idProducto}/${String(producto.titulo || 'producto').replace(/\s+/g, '-')}`;
                        return (
                            <div key={producto.idProducto}>
                                {LinkComponent === 'a' ? (
                                    <a href={href} onClick={closeModal}>
                                        <img src={searchImageUrl(producto.imagen1)} alt="" loading="lazy" decoding="async" />
                                        <p>{producto.titulo}</p>
                                    </a>
                                ) : (
                                    <Link to={href} onClick={closeModal}>
                                        <img src={searchImageUrl(producto.imagen1)} alt="" loading="lazy" decoding="async" />
                                        <p>{producto.titulo}</p>
                                    </Link>
                                )}
                            </div>
                        );
                    })}
                    {productos?.length > (visibleProducts[categoria?.idCategoria] || 5) && (
                        <button onClick={() => handleShowMore(categoria)} className="show-more-btn2">Mostrar mas</button>
                    )}
                </div>
            ))}
            {noResults && <p>No se encontraron resultados.</p>}
        </>
    );

    return (
        <div className="fondo-input">
            {isScreenLarge ? (
                <div className="search-container">
                    <fieldset className="inputSearch">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onFocus={ensureSearchData}
                            onChange={handleSearch}
                            className="input"
                        />
                    </fieldset>
                    {showResults && (
                        <div className="modalSearch">
                            {renderResults('a')}
                        </div>
                    )}
                </div>
            ) : (
                <div className="search-container">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" onClick={openModal} />
                    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="modalInput" overlayClassName="overlayInput">
                        <fieldset className="inputSearch">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onFocus={ensureSearchData}
                                onChange={handleSearch}
                                className="input"
                            />
                        </fieldset>
                        {showResults && (
                            <div className="modalSearch">
                                {renderResults(Link)}
                            </div>
                        )}
                    </Modal>
                </div>
            )}
        </div>
    );
}
